export default function SearchItem(props) {
    return (
        <div className="recent-item d-flex align-items-center" onClick={props.onClick}>
            <img src={props.image} alt={props.name} className="thumbnail" />
            <i className="bi bi-clock-history me-2"></i>
            <span>{props.name} ({props.releaseYear})</span>
        </div>
    )
}